export default {
    'category': 'التصنيفات ',
    'add-product': 'إضافة منتج',
    'edit-product': 'تعديل منتج',
    'the-product': 'بيانات المنتج؟',
    'product-is-added': 'تمت إضافة المنبج',
    'product-is-edited': 'تم تعديل المنتج',
    'delete-product': 'حذف منتج',
    'this-product': 'هذا المنتج'
}